import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import ReactSVG from "react-svg";
import cx from "classnames";
import Actions from "./Actions";

import "./styles.scss";

const Breadcrumbs = props => {
    const {
        t,
        className,
        breadcrumbs,
        setBreadCrumbs,
        currentId,
        customerActions,
        contactPersonActions,
        mainActions,
        history,
        // withCollapseButton,
        collapseState,
        onCollapseClick,
        location: { pathname: currentPath },
        match: {
            params: { subTab, id },
        },
    } = props;

    useEffect(() => {
        // id === customer Id - do not update breadcrumbs from customer tab
        if (breadcrumbs && !id) {
            // do not update false breadcrumbs (when id are not synced)
            const isIncluded = breadcrumbs.find(item => item.type === "main" && +item.id === +currentId);
            if (!isIncluded) {
                return;
            }
            const breadcrumbsData = breadcrumbs.map(crumb => (+crumb.id === +currentId ? { ...crumb, subTab } : crumb));
            setBreadCrumbs(breadcrumbsData);
        }
    }, [subTab]);

    const renderBreadcrumbs = (data, index) => {
        const { type, id, statusClassName, path, locked, name, statusCode, statusName, subTab, code, icon } = data;
        const toPath = subTab ? `${path}/${subTab}` : path;

        const withCustomerActions = customerActions && type === "customer";
        const withContactPersonActions = contactPersonActions && type === "contactPerson";
        const withMainActions = mainActions && !["customer", "contactPerson"].includes(type);
        const withActions = withMainActions || withContactPersonActions || withCustomerActions;

        const nextCrumb = breadcrumbs[index + 1];
        let isNextActive = false;
        if (nextCrumb && +nextCrumb.id === +currentId) {
            isNextActive = true;
        }

        const prevCrumb = breadcrumbs[index - 1];
        let isPrevActive = false;
        if (prevCrumb && +prevCrumb.id === +currentId) {
            isPrevActive = true;
        }

        return (
            <div
                className={cx("breadcrumb", {
                    active: +currentId === +id,
                    "is-next-active": isNextActive,
                    "is-prev-active": isPrevActive,
                })}
                key={id}
            >
                <div className="breadcrumb-link">
                    <div
                        className={cx("breadcrumb-link-wrapper", {
                            "with-actions": withActions,
                        })}
                        onClick={() => currentPath !== toPath && history.push(toPath)}
                    >
                        {icon && <ReactSVG className="tab-svg-wrapper" svgClassName="tab-svg" src={`/data/svg/${icon}.svg`} />}
                        <span title={code ? `${code} ${name}` : name}>
                            {code} {name}
                        </span>

                        {locked && <i className="icon icon-lock" />}

                        {type === "crumb" && <i className={`icon icon-circle ${statusCode}`} title={statusName} />}

                        {type === "main" && (
                            <div title={statusName} className={`status breascrumb-status ${statusCode} ${statusClassName || ""}`}>
                                <span>{statusName}</span>
                            </div>
                        )}
                    </div>
                    {withCustomerActions && <Actions breadcrumbData={data} actions={customerActions} /> }
                    {withContactPersonActions && <Actions breadcrumbData={data} actions={contactPersonActions} />}
                    {withMainActions && (
                        <Actions breadcrumbData={data} actions={mainActions} />
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className={cx("breadcrumbs-ordering-container", {
            [className]: className,
            "with-collapse": collapseState && onCollapseClick,
        })}>
            {collapseState && onCollapseClick ? (
                <div className="button-hover-half-circle button-collapse-state" onClick={onCollapseClick}>
                    <ReactSVG
                        className="button-icon button-icon-size"
                        src={`/data/svg/tab-left-${collapseState}.svg`}
                    />
                </div>
            ) : (<div className="empty-collapse-placeholder"></div>)}
            <div
                className={cx("breadcrumbs breadcrumbs-ordering", {
                    // [className]: className,
                    // "with-collapse": collapseState && onCollapseClick,
                })}
            >
                {breadcrumbs && breadcrumbs.map(renderBreadcrumbs)}
            </div>
        </div>
    );
};

export default withTranslation()(withRouter(Breadcrumbs));
